<template>
     <div class="col-md-12" style="margin-bottom: 50px;">
        <b-container style="margin-bottom: 50px;">
        <b-row>
        <b-col sm="1">
        </b-col>
        <b-col sm="10">
        <div class="row" v-bind:hidden="loadedData">
            <div style="text-align: center;" class="col-md-12">
                <img src="../assets/loading.gif" style="text-align: center; height: 100px;"><br>
                <h2>Loading ...</h2>
            </div>
        </div>
        <div v-if="loadedData">
        <b-container>
            <b-row>
                <div class="col-md-9">
                </div>
                <div style="text-align: right; background-color:#91C85F;" class="col-md-3">
                <b-button block size="lg" :to="{name: 'viewoutcome', params:{id: item.outcome.id}}"
                          variant="outline-none" class="align-items-center d-flex justify-content-center" style="border-radius: unset; border: none; outline:none; background-color:#91C85F; font-size:17px; font-weight:600; color:dark;">
                   <b-icon-pencil></b-icon-pencil> Edit
                </b-button>
                </div>
            </b-row>
            <!--<b-row class="mt-2">
                <div class="col-md-9">
                </div>
                <div style="text-align: right; background-color:#91C85F;" class="col-md-3">
                <b-row class="">    
                 <b-button block size="lg" @click="deletereport" variant="outline-none" style="border-radius: unset; border: none; outline:none; background-color:#565754; font-size:17px; font-weight:600; color:white;"
                          class="align-items-center d-flex justify-content-center">
                    <b-icon-trash variant="light"></b-icon-trash> Delete
                </b-button>
                 </b-row>
                </div>
            </b-row>-->
        </b-container>
            <div id="generatedHtml" style="margin-bottom: 30px;">
                <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css"
                      integrity="sha384-Vkoo8x4CGsO3+Hhxv8T/Q5PaXtkKtu6ug5TOeNV6gBiFeWPGFN9MuhOf23Q9Ifjh"
                      crossorigin="anonymous">

                <div v-html="pdfStyle"></div>
                <b-container style="background-color:#565754;" class="mt-3">
                <b-row>
                <b-col sm="1">
                </b-col>
                <b-col sm="10">
                <div class="col-md-12">
                    <p class="mt-3" style="font-family:Roboto; font-size:22px; color:white;" >Outcome Title: {{ outcomeTitle }}</p>
                </div>
                <div class="col-md-12 mb-2">
                    <p class="" style="font-family:Roboto; font-size:22px; color:white;">Generated On: {{ generatedOn }}</p>
                </div>
                </b-col>
                <b-col sm="1">
                </b-col>
                </b-row>
                </b-container>
                <b-container style="background-color:#F4F4F4;" class="mt-3 mb-4">
                    <b-row>
                        <b-col sm="1">
                        </b-col>
                        <b-col sm="10" class="mt-3 mb-4">
                            <div class="col-md-12">
                                <h6 class="mheader" style="font-family:Roboto; font-size:20px; font-weight:600;">Reporting Period</h6>
                                <span style="font-family:Roboto; font-size:18px;" v-html="this.item.period.period"/>
                            <hr style="" class="divider"/>
                            </div>
                            <div v-bind:hidden="this.item.outcome.outcome_summary == null" class="col-md-12 mt-3">
                                <h6 class="mheader" style="font-family:Roboto; font-size:20px; font-weight:600;">Summary</h6>
                                <p style="font-family:Roboto; font-size:18px; word-break: break-word;" v-html="this.item.outcome.outcome_summary"></p>
                            <hr style="" class="divider"/>
                            </div>
                            <div v-bind:hidden="this.item.outcome.ed_mandate == null" class="col-md-12 mt-3">
                                <h6 class="mheader" style="font-family:Roboto; font-size:20px; font-weight:600;">Executive Director's Mandate</h6>
                                <p style="font-family:Roboto; font-size:18px; word-break: break-word;" v-html="this.item.outcome.ed_mandate"></p>
                            <hr style="" class="divider"/>
                            </div>
                            <div v-bind:hidden="this.item.outcome.actions_required == null" class="col-md-12 mt-3">
                                <h6 class="mheader" style="font-family:Roboto; font-size:20px; font-weight:600;">Actions
                                    Required</h6>
                                <p style="font-family:Roboto; font-size:18px; word-break: break-word;" v-html="this.item.outcome.actions_required"></p>
                             <hr style="" class="divider"/>
                            </div>
                            <div v-bind:hidden="this.item.implementationplans_model == null" class="col-md-12 mt-3">
                                <h6 class="mheader" style="font-family:Roboto; font-size:20px; font-weight:600;">Implementation
                                    Plan</h6> 
                                <p style="font-family:Roboto; font-size:18px; word-break: break-word;" v-html="this.item.implementationplans_model"></p>
                                <hr style="" class="divider"/>
                            </div>
                            <!--<div class="col-md-12">
                                <h6 class="mheader" style="font-family:Roboto; font-size:20px; font-weight:600;">Milestone</h6>
                                <p v-bind:hidden="this.item.model.milestone_description == null"  style="font-family:Roboto; font-size:18px; word-break: break-word;" v-html="this.item.model.milestone_description"></p>
                            </div>-->
                            <div v-bind:hidden="!this.item.milestone_report_model.length"  class="col-md-12">
                                 <h6 class="mheader mb-3" style="font-family:Roboto; font-size:20px; font-weight:600;">Milestone</h6>
                                <table class="rtable table-bordered" style="border: 2px solid black ;">
                                    <colgroup>
                                    <col span="1" style="width: 7%;">
                                    <col span="1" style="width: 70%;">
                                    <col span="1" style="width: 23%;">
                                    </colgroup>
                                    <thead>
                                    <th  style="font-weight:600; font-size:18px; border: 2px solid black ; ">No</th>
                                    <th  style="font-weight:600; font-size:18px; border: 2px solid black ; ">Milestone</th>
                                    <th  style="font-weight:600; font-size:18px; border: 2px solid black ; ">Status</th>
                                    </thead>

                                    <tbody>
                                    <tr v-for="milestone_text in this.item.milestone_report_model" :key="milestone_text.id" style="">
                                        <td  style="font-family:Roboto; font-size:17px; border: 2px solid black ;"></td>
                                        <td  style="font-family:Roboto; font-size:17px; border: 2px solid black ;">
                                                 {{ milestone_text.milestone_text }}
                                        </td>
                                        <td  style="font-family:Roboto;  font-size:17px; border: 2px solid black ; font-weight:500;">
                                            {{ milestone_text.status_name}}
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                                <hr style="" class="divider"/>
                            </div>
                            <div v-bind:hidden="!this.item.result_report_model.length" class="col-md-12 mt-3" >
                                 <h6 class="mheader" style="font-family:Roboto; font-size:20px; font-weight:600;">Results</h6>
                                <ul>
                                <li v-for="results in this.item.result_report_model" :key="results.id" style="">
                                    <b style="font-family:Roboto; font-size:18px; word-break: break-word;" v-html="results.result_category_id"></b>
                                    <p style="font-family:Roboto; font-size:18px; word-break: break-word;" v-html="results.result_text"></p>
                                </li>
                                </ul>
                            <hr style="" class="divider"/>
                            </div> 
                            <div v-bind:hidden="this.item.model.output == null" class="col-md-12 mt-3">
                                    <h6 class="mheader" style="font-family:Roboto; font-size:20px; font-weight:600;">Outcome</h6>
                                    <p style="font-family:Roboto; font-size:18px; word-break: break-word;" v-html="this.item.model.output"></p>
                            <hr style="" class="divider"/>
                            </div>
                            <div v-bind:hidden="this.item.model.impact == null" class="col-md-12 mt-3">
                                    <h6 class="mheader" style="font-family:Roboto; font-size:20px; font-weight:600;">Impact</h6>
                                    <p style="font-family:Roboto; font-size:18px; word-break: break-word;" v-html="this.item.model.impact"></p>
                            <hr style="" class="divider"/>
                            </div>
                            <div v-bind:hidden="!this.item.resources_model.length" class="col-md-12 mt-3" >
                                <h6 class="mheader" style="font-family:Roboto; font-size:20px; font-weight:600;">Resources</h6>
                                <li v-for="resources in this.item.resources_model" :key="resources.id" style="list-style-type: none;">
                                    <b style="font-family:Roboto; font-size:18px; word-break: break-word;" v-html="resources.resource_category_id1"></b>
                                    <p style="font-family:Roboto; font-size:18px; word-break: break-word;" v-html="resources.resource1"></p>
                                    <b style="font-family:Roboto; font-size:18px; word-break: break-word;" v-html="resources.resource_category_id2"></b>
                                    <p style="font-family:Roboto; font-size:18px; word-break: break-word;" v-html="resources.resource2"></p>
                                </li> 
                             <hr style="" class="divider"/>
                            </div> 
                            <div  class="col-md-12 mt-3">
                                    <h5 class="mheader" style="font-family:Roboto; font-size:20px; font-weight:600;">LEARNING</h5> 
                            <hr style="" class="divider"/>
                            </div>
                            <div v-bind:hidden="this.item.bestpractices_model == null" class="col-md-12 mt-3">
                                    <h6 class="mheader" style="font-family:Roboto; font-size:20px; font-weight:600;">Best
                                        practices</h6>
                                    <p style="font-family:Roboto; font-size:18px; word-break: break-word;" v-html="this.item.bestpractices_model"></p>
                            <hr style="" class="divider"/>
                            </div>
                            <div v-bind:hidden="this.item.opportunities_model== null" class="col-md-12 mt-3">
                                    <h6 class="mheader" style="font-family:Roboto; font-size:20px; font-weight:600;">
                                        Opportunities</h6>
                                    <p style="font-family:Roboto; font-size:18px; word-break: break-word;" v-html="this.item.opportunities_model"></p>
                            <hr style="" class="divider"/>
                            </div> 
                            
                            <div v-bind:hidden="!this.item.challenges_model.length" class="col-md-12 mt-3" >
                                 <h6 class="mheader" style="font-family:Roboto; font-size:20px; font-weight:600;">Challenges</h6>
                                <ul>
                                <li v-for="challenges in this.item.challenges_model" :key="challenges.id" style="">
                                    <b style="font-family:Roboto; font-size:18px; word-break: break-word;" v-html="challenges.challenge_category"></b>
                                    <p style="font-family:Roboto; font-size:18px; word-break: break-word;" v-html="challenges.challenge"></p>
                                </li>
                                </ul>
                            <hr style="" class="divider"/>
                            </div>
                            
                            <div v-bind:hidden="!this.item.risks_model.length" class="col-md-12 mt-3" >
                                 <h6 class="mheader" style="font-family:Roboto; font-size:20px; font-weight:600;">Risks</h6>
                                <ul>
                                <li v-for="risks in this.item.risks_model" :key="risks.id" style="">
                                    <b style="font-family:Roboto; font-size:18px; word-break: break-word;" v-html="risks.risk_category"></b>
                                    <p style="font-family:Roboto; font-size:18px; word-break: break-word;" v-html="risks.risk"></p>
                                </li>
                                </ul>
                            <hr style="" class="divider"/>
                            </div>
                            <div v-bind:hidden="this.item.keylessons_model == null" class="col-md-12 mt-3">
                                    <h6 class="mheader" style="font-family:Roboto; font-size:20px; font-weight:600;">Key
                                        lessons</h6> 
                                    <p style="font-family:Roboto; font-size:18px; word-break: break-word;" v-html="this.item.keylessons_model"></p>
                            <hr style="" class="divider"/>  
                            </div> 
                            
                            <div v-bind:hidden="!this.item.partners_model.length" class="col-md-12 mt-3" >
                                 <h6 class="mheader" style="font-family:Roboto; font-size:20px; font-weight:600;">Partners</h6>
                                 <table class="rtable table-bordered" style="border: 2px solid black ;">
                                    <colgroup>
                                    <col span="1" style="width: 7%;">
                                    <col span="1" style="width: 40%;">
                                    <col span="1" style="width: 53%;">
                                    </colgroup>
                                    <thead>
                                    <th  style="font-weight:600; font-size:18px; border: 2px solid black ; ">No</th>
                                    <th  style="font-weight:600; font-size:18px; border: 2px solid black ; ">Partner Category</th>
                                    <th  style="font-weight:600; font-size:18px; border: 2px solid black ; ">Partner</th>
                                    </thead>

                                    <tbody>
                                    <tr v-for="partners in this.item.partners_model" :key="partners.id" style="">
                                        <td  style="font-family:Roboto; font-size:17px; border: 2px solid black ;"></td>
                                        <td  style="font-family:Roboto; font-size:17px; border: 2px solid black ;">
                                                 {{ partners.partner_category }}
                                        </td>
                                        <td  style="font-family:Roboto;  font-size:17px; border: 2px solid black ; font-weight:500;">
                                            {{ partners.partner}}
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            <hr style="" class="divider"/>
                            </div>
                            <div v-bind:hidden="!this.item.pow_outcome_model.length" class="col-md-12 mt-3">
                                <h6 class="mheader" style="font-family:Roboto; font-size:20px; font-weight:600;">Link to Programme of Work</h6>
                                <ul>
                                    <li v-for="pow in this.item.pow_outcome_model" :key="pow.id" style="">
                                        <p style="font-family:Roboto; font-size:18px; word-break: break-word;" v-html="pow.pow"></p>
                                    </li>
                                </ul>
                            <hr style="" class="divider"/>
                            </div>
                            <div class="col-md-12 mt-3" >
                                <h6 class="mheader"
                                   style="font-family:Roboto; font-size:20px; font-weight:600;">Link to Projects</h6>
                                <ul  v-bind:hidden="!this.item.project_outcome_model.length">
                                    <li v-for="project in this.item.project_outcome_model" :key="project.id" style="">
                                        <p style="font-family:Roboto; font-size:18px; word-break: break-word;" v-html="project.project"></p>
                                    </li>
                                </ul>
                            </div>
                             <div class="col-md-12 mt-3" >
                                <h6 class="mheader"
                                   style="font-family:Roboto; font-size:20px; font-weight:600;"></h6>
                                <ul>
                                <li v-for="project in this.item.project_report_model" :key="project.id" style="">
                                    <p style="font-family:Roboto; font-size:18px; word-break: break-word;" v-html="project.project_name"></p>
                                </li>
                                </ul>
                            <hr style="" class="divider"/>
                            </div>
                            <div v-bind:hidden="!this.item.sdg_outcome_model.length" class="col-md-12 mt-3">
                                <h6 class="mheader" style="font-family:Roboto; font-size:20px; font-weight:600;">Contribution to
                                    Higher Goals (SDGs)</h6>
                                <!--<ul>
                                        <li v-for="sdg in this.item.sdg_outcome_model" :key="sdg.id" style="">
                                            <p style="font-family:Roboto; font-size:18px; word-break: break-word;" v-html="sdg.sdg"></p>
                                        </li>
                                </ul>-->
                                 <b-col class="column_wrapper" style="column-count:4">
                                 <b-card-text v-for="sdg in this.item.sdg_outcome_model" :key="sdg.id" style="font-family:roboto; font-size:17px;" class="">
                                         <span><img :src="sdg.image" style="width: 60%;"></span><br>
                                 </b-card-text>
                                 </b-col>
                                <hr style="" class="divider"/>
                            </div>
                            <!--<div class="col-md-12 mt-3">
                                <h6 class="mheader" style="font-family:Roboto; font-size:20px; font-weight:600;">MEAs</h6>
                                    <p v-bind:hidden="this.item.model.meas == null" style="font-family:Roboto; font-size:18px; word-break: break-word;" v-html="this.item.model.meas"></p>
                            </div>-->
                            <div v-bind:hidden="!this.item.meas_report_model.length" class="col-md-12 mt-3" >
                                 <h6 class="mheader" style="font-family:Roboto; font-size:20px; font-weight:600;">MEAs</h6>
                                <ul>
                                <li v-for="meas_name in this.item.meas_report_model" :key="meas_name.id" style="">
                                    <p style="font-family:Roboto; font-size:18px; word-break: break-word;" v-html="meas_name.meas_name"></p>
                                </li>
                                </ul>
                            <hr style="" class="divider"/>
                            </div>
                            <div v-bind:hidden="this.item.model.national == null" class="col-md-12 mt-3">
                                <h6 class="mheader" style="font-family:Roboto; font-size:20px;">Relevance to
                                    National & Regional Priorities</h6>
                                <p style="font-family:Roboto; font-size:18px; word-break: break-word;" v-html="this.item.national.national_option"></p>
                                <p style="font-family:Roboto; font-size:18px; word-break: break-word;" v-html="this.item.model.national"></p>
                            </div>
                            <div v-bind:hidden="this.item.nextsteps_model == null" class="col-md-12 mt-3">
                                <h6 class="mheader" style="font-family:Roboto; font-size:20px; font-weight:600;">Next steps</h6>
                                <p style="font-family:Roboto; font-size:18px; word-break: break-word;" v-html="this.item.nextsteps_model"></p>
                            </div>
                        </b-col>
                        <b-col sm="1">
                        </b-col>
                    </b-row>
                </b-container>
                </div>
            </div>
        </b-col>
        <b-col sm="1">
        </b-col>
        </b-row>
        </b-container>
    </div>
</template>

<script>
    export default {
        name: 'ViewReportPage',
        components: {},
        data() {
            return {
                loadedData: false,
                apiUrl: process.env.VUE_APP_API_PATH,
                processingMessage: '',
                id: 0,
                item: null,
                generatingPdfMessage: '',
                show: true,
            }
        },
        computed: {
            pdfStyle() {
                return '<style>' +
                    'h5 {\n' +
                    '    color: rgb(0, 0, 0);\n' +
                    '    font-weight: bolder;\n' +
                    '    font-size: 14px;\n' +
                    '    font-family:roboto;\n' +
                    '  }' +
                    '.arow {\n' +
                    '    background-color: azure;\n' +
                    '    padding: 20px;\n' +
                    '    border-radius: 10px;\n' +
                    '  }' +
                    '</style>';
            },
            generatedOn() {
                return (new Date().toJSON().slice(0, 10).replace(/-/g, '/'));
            },
            reportType() {
                try {
                    if (this.item.model.type == '1') {
                        return "Secretariat Report";
                    }
                } catch (e) {
                    console.log(e)
                }

                return "Member States Report";
            },
            outcomeTitle() {
                try {
                    return this.item.outcome_type_model.outcome_type + " " + this.item.outcome.outcome_code + ": " + this.item.outcome.outcome_name;
                } catch (e) {
                    return "Loading ...";
                }
            }
        },
        methods: {
            deletereport() {
                if (confirm("Are you sure you want to delete this Report?")) {
                    this.processingMessage = "<span style='color: orange;'>Deleting Report ...</span>"
                    let url = this.apiUrl + '/deletereport/' + this.id;
                    fetch(url, {
                        method: 'post',
                        headers: {'Content-Type': 'application/json'}
                    })
                        .then((res) => {
                            if (!res.ok) {
                                throw new Error("HTTP status " + res.status);
                            }
                            return res.json();
                        })
                        .then(res => {
                            if (res.success) {
                                this.processingMessage = "<span style='color: green;'>Report has been deleted successfully.</span>";
                                setTimeout(() => {
                                    this.processingMessage = '';
                                    this.$router.push('/my-reports');
                                }, 1000);
                            } else {
                                this.processingMessage = "<span style='color: red;'>Error occurred: " + res.message + "</span>";
                            }
                        }).catch(error => {
                        this.processingMessage = "<span style='color: red;'>Error occurred: " + error + "</span>";
                    });
                }
            },
            fetchData() {
                let url = this.apiUrl;
                fetch(url + '/getviewreport?id=' + this.id)
                    .then(res => res.json())
                    .then(res => {
                        this.item = res;
                        this.loadedData = true;
                    });
            },
            generatepdf() {
                var divContents = document.getElementById("generatedHtml").innerHTML;
                var a = window.open('', '', '');
                a.document.write('<html>');
                a.document.write(divContents);
                a.document.write('</body></html>');
                a.document.close();
                a.print();
            }
        },
        created() {
            this.id = this.$route.params.id;
        },
        mounted() {
            this.fetchData();
        },
    }
</script>

<style>
.rtable {
  counter-reset: row-num;
  border-color: black;
}
.rtable tr {
  counter-increment: row-num;
}
.rtable tr td:first-child::before {
    content: counter(row-num) ". ";
}
</style>